import { combineReducers } from "redux";
import { LoyaltyLevelType } from "../../types/entities";
import * as actions from "../../actions/types";

const loyaltyLevel = (state: LoyaltyLevelType | null = null, action) => {
    switch (action.type) {
        case actions.AUTH_SHOW_REGISTER:
            return null;
        case actions.AUTH_SIGN_UP_LOYALTY_LEVEL_SELECT:
            return action.payload.level || null;
        default:
            return state;
    }
};

const cinemaId = (state: number | null = null, action) => {
    switch (action.type) {
        case actions.AUTH_SHOW_REGISTER:
            return null;
        case actions.AUTH_SIGN_UP_LOYALTY_LEVEL_SELECT:
            return action.payload.level && action.payload.cinemaId ? action.payload.cinemaId : null;
        default:
            return state;
    }
};

export const getSignUpCinemaId = (state): number | null => state.auth.signUp.cinemaId;
export const getSignUpLoyaltyLevel = (state): LoyaltyLevelType | null => state.auth.signUp.loyaltyLevel;

export default combineReducers({
    cinemaId,
    loyaltyLevel,
});